import React from "react";
import { Modal, Button, Select } from "../..";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import styles from "./index.module.css";
import {
  RESCHEDULE_ROUNDTRIP_POPUP_TITLE,
  RIDE_RESCHEDULED_REASONS,
  UBER_TEXT,
} from "../../../constants/constants";
import { RidePickUpInfo } from "../../common/RideDetails/RideDetailsPartials/RidePickUpInfo";
import { RideDestinationInfo } from "../../common/RideDetails/RideDetailsPartials/RideDestinationInfo";

export const ConfirmRescheduleRideModal = ({
  ride,
  handleConfirm,
  handleCancel,
  isSubmitting = false,
  isUberReRequest = false,
}) => {
  const validationSchema = Yup.object({
    reason: Yup.string().required(
      isUberReRequest
        ? UBER_TEXT.RESCHEDULE_REASON_UBER
        : UBER_TEXT.RESCHEDULE_REASON_GENERIC
    ),
  });

  const handleSubmit = (value) => {
    if (isSubmitting) return;
    handleConfirm(value.reason);
  };

  const initialValues = {
    reason: undefined
  };

  return (
    <Modal
      visible={true}
      onCancel={handleCancel}
      closable
      width="auto"
      wrapClassName={styles.modal}
      styles={{ body: { padding: "15px 15px 0" } }}
      title={
        ride?.connectedLeg
          ? RESCHEDULE_ROUNDTRIP_POPUP_TITLE
          : isUberReRequest
            ? `${UBER_TEXT.RESCHEDULE_MODAL_TITLE_PREFIX_UBER} ${ride?.seqId}`
            : `${UBER_TEXT.RESCHEDULE_MODAL_TITLE_PREFIX_GENERIC} ${ride?.seqId}`
      }
    >
      <>
      {!isUberReRequest && (
        <h3 className={styles.text_center}>{UBER_TEXT.RESCHEDULE_MODAL_HEADING}</h3>
      )}
        {ride?.connectedLeg && (
          <div className={styles.routes}>
            <RidePickUpInfo
              pickupAddressDetails={ride?.pickupAddressDetails}
              destinationAddress={ride?.destinationAddress}
              pickUpDate={ride?.pickUpDate}
              riderDescription={ride?.riderDescription}
              pickUpDateLowerLimit={ride?.pickUpDateLowerLimit}
              isPickUpDateFlexible={ride?.isPickUpDateFlexible}
              tcEstimatedPickUpDate={ride?.tcEstimatedPickUpDate}
              securityGate={ride?.pickUpSecurityGateDetails}
              flightInfo={ride?.flightInfo}
              appointmentDate={ride?.appointmentDate}
              isRecurringRide={ride?.isRecurring}
              leg={ride?.leg}
              seqId={ride?.seqId}
            />

            <div className={styles.destionationRouteInfo}>
              <RideDestinationInfo
                destinationAddress={ride?.destinationAddress}
                originAddress={ride?.pickupAddressDetails}
                showRoundtripInfo={ride?.isRoundtrip && ride?.leg}
                securityGate={ride?.destinationSecurityGateDetail}
                returnTime={ride?.connectedLeg?.pickUpDate}
                returnTimeLowerLimit={ride?.returnTimeLowerLimit}
                isReturnDateFlexible={ride?.isReturnDateFlexible}
                leg={ride?.connectedLeg?.leg}
                seqId={ride?.connectedLeg?.seqId}
              />
            </div>
          </div>
        )}

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          validateOnMount
        >
          {({ values, isValid }) => (
            <Form>
              <div className={styles.modalContent}>
                <p className={styles.modalDescription}>
                  {isUberReRequest
                    ? UBER_TEXT.RESCHEDULE_MODAL_DESC_UBER
                    : UBER_TEXT.RESCHEDULE_MODAL_DESC_GENERIC}
                </p>
                <div className={styles.selectGroup}>
                  <Select
                    name="reason"
                    options={RIDE_RESCHEDULED_REASONS}
                    value={values.reason}
                    placeholder={
                      isUberReRequest
                        ? "Select a re-request reason"
                        : UBER_TEXT.RESCHEDULE_MODAL_PLACEHOLDER
                    }
                  />
                </div>
                <div className={styles.modalBtns}>
                <div>
                    <Button
                      myClassName={styles.navigationBtn}
                      onClick={handleCancel}
                      disabled={isSubmitting}
                    >
                      {UBER_TEXT.RESCHEDULE_MODAL_CANCEL}
                    </Button>
                  </div>
                  <div>
                    <Button
                      myClassName={styles.navigationBtn}
                      onClick={() => handleSubmit(values)}
                      disabled={!isValid || isSubmitting}
                    >
                      {isSubmitting
                        ? UBER_TEXT.RESCHEDULE_MODAL_SUBMITTING
                        : isUberReRequest
                          ? UBER_TEXT.RESCHEDULE_MODAL_PRIMARY_UBER
                          : UBER_TEXT.RESCHEDULE_MODAL_PRIMARY_GENERIC}
                    </Button>
                  </div>
                  
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </>
    </Modal>
  );
};
